import { useQuery } from '@tanstack/react-query';
import { useStore } from '@nanostores/react';
import { accountStore } from '@/services/auth/store';

// only the features CDP cares about
export const PlanFeature = {
  CdpPremiumIntegrations: 'cdp_premium_integrations',
} as const;
export type PlanFeature = (typeof PlanFeature)[keyof typeof PlanFeature];

export const useIsPlanFeatureEnabled = (feature: PlanFeature) => {
  const account = useStore(accountStore);
  return useQuery({
    queryKey: [
      'gatedFeatures',
      {
        account,
        feature,
      },
    ],
    queryFn: async () => {
      if (account == null || account.gated_features == null) {
        return Promise.reject();
      }

      // If a feature is present on the gatedFeatures object, it is enabled.
      const isEnabled = feature in account.gated_features;

      return Promise.resolve(isEnabled);
    },
  });
};
